<template>
  <div>
    <div class="header">
      <div class="header-mo-element position-relative col-10 m-auto">
        <div class="home-slider col-md-9 m-auto">
          <swiper
            :slides-per-view="1"
            :space-between="0"
            :navigation="false"
            class="home-slider-container"
            :loop="false"
            :key="swiperSliderKey"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide class="position-relative slide-magnifier">
              <div class="f-30 fw-bold text-gray2">
                <img
                  src="/assets/img/magnifier.png"
                  alt="magnifier"
                  class="magnifier-img"
                />
                با <span class="text-primary ms-2">ایران سفر ،</span> راحت سفر
                کن
              </div>
              <div
                class="f-18 text-gray2 mt-2 text-end pe-md-5 subtitle-slider"
              >
                <div class="d-inline-block has-line-below">
                  یه مشاوره واقعی بدون هزینه برای یک سفری هیجان انگیز به عمق
                  ایران
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <img
          src="/assets/img/right-cloud.png"
          width="130"
          height="53"
          alt="cloud"
          class="clouds first-claud"
        />
        <img
          src="/assets/img/balloon.png"
          width="67"
          height="80"
          class="balloon"
          alt="balloon"
        />
        <img
          src="/assets/img/second-cloud.png"
          width="96"
          height="45"
          alt="cloud"
          class="clouds second-cloud"
        />
        <img
          src="/assets/img/third-cloud.png"
          width="120"
          height="43"
          alt="cloud"
          class="clouds third-cloud"
        />
        <img
          src="/assets/img/fourth-cloud.png"
          width="149"
          height="53"
          alt="cloud"
          class="clouds fourth-cloud"
        />
        <img
          src="/assets/img/sun.png"
          width="90"
          height="97"
          alt="sun"
          class="sun"
        />
        <img
          src="/assets/img/fiveth-cluad.png"
          width="92"
          height="48"
          alt="cloud"
          class="clouds five-cloud"
        />
        <img
          src="/assets/img/city-header.png"
          width="774"
          height="308"
          alt="cloud"
          class="city-img"
        />
        <img
          src="/assets/img/air.png"
          width="127"
          height="119"
          alt="air"
          class="air-img"
        />
        <img src="/assets/img/car.png" alt="car" class="home-car" />
      </div>

      <div class="home-search-container col-10 m-auto position-relative">
        <ul
          class="nav nav-tabs justify-content-between"
          id="myTab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="hotel-tab"
              data-bs-toggle="tab"
              data-bs-target="#hotel"
              type="button"
              role="tab"
              aria-controls="hotel"
              aria-selected="true"
              @click="loadHotels"
            >
              <HotelIcon />
              هتل
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="vila-tab"
              data-bs-toggle="tab"
              data-bs-target="#vila"
              type="button"
              role="tab"
              aria-controls="vila"
              aria-selected="false"
              @click="getResidence"
            >
              <Eghamatgah />
              ویلا و اقامتگاه
            </button>
          </li>
          <!--<li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="keridor-tab"
              data-bs-toggle="tab"
              data-bs-target="#keridor"
              type="button"
              role="tab"
              aria-controls="keridor"
              aria-selected="false"
            >
              <CoridorIcon />
              کریدور
            </button>
          </li>-->
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="restaurants-tab"
              data-bs-toggle="tab"
              data-bs-target="#restaurants"
              type="button"
              role="tab"
              aria-controls="restaurants"
              aria-selected="false"
              @click="getRestaurant"
            >
              <RsturanIcon />
              رستوران
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="tour-tab"
              data-bs-toggle="tab"
              data-bs-target="#tour"
              type="button"
              role="tab"
              aria-controls="tour"
              aria-selected="false"
              @click="getTour"
            >
              <TurIcon />
              تور
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="hotel"
            role="tabpanel"
            aria-labelledby="hotel-tab"
          >
            <form class="row g-3 input-frm mt-0 top-search">
              <div class="col-6 mb-md-0 mb-2">
                <input
                  type="text"
                  class="form-control"
                  id="typeHotel"
                  placeholder="جستجو نام هتل"
                  v-model="hotelName"
                />
              </div>
              <div class="col-md-4 col-6">
                <select
                  class="form-select border-blue text-muted f-12 p-2"
                  aria-label="Default select example"
                  v-model="hotelCitySelected"
                >
                  <option selected value="0">انتخاب شهر مقصد</option>
                  <option
                    v-for="(city, index) in hotelCities"
                    :key="index"
                    v-if="hotelCities.length > 0"
                    :value="city.id"
                  >
                    {{ city.name }}
                  </option>
                </select>
              </div>
              <!--<div class="col-md-2 col-6">
              <input
                type="text"
                class="form-control"
                id="transDate"
                placeholder="تعیین تاریخ رفت و برگشت"
              />
            </div>
            <div class="col-md-2 col-6">
              <select class="form-select" aria-label="Default select example">
                <option selected>تعداد مسافران</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>-->
              <div class="col-md-2">
                <button
                  type="button"
                  @click="sendHotel"
                  class="btn yellow-btn w-100 mt-md-0 mt-2"
                >
                  جستجو
                </button>
              </div>
            </form>
          </div>
          <div
            class="tab-pane fade"
            id="vila"
            role="tabpanel"
            aria-labelledby="vila-tab"
          >
            <form class="row g-3 input-frm mt-0 top-search">
              <div class="col-6 mb-md-0 mb-2">
                <input
                  type="text"
                  class="form-control"
                  id="typeHotel"
                  placeholder="جستجو نام اقامتگاه"
                  v-model="hotelName"
                />
              </div>
              <div class="col-md-4 col-6">
                <select
                  class="form-select border-blue text-muted f-12 p-2"
                  aria-label="Default select example"
                  v-model="hotelCitySelected"
                >
                  <option selected value="0">انتخاب شهر مقصد</option>
                  <option
                    v-for="(city, index) in hotelCities"
                    :key="index"
                    v-if="hotelCities.length > 0"
                    :value="city.id"
                  >
                    {{ city.name }}
                  </option>
                </select>
              </div>
              <!--<div class="col-md-2 col-6">
              <input
                type="text"
                class="form-control"
                id="transDate"
                placeholder="تعیین تاریخ رفت و برگشت"
              />
            </div>
            <div class="col-md-2 col-6">
              <select class="form-select" aria-label="Default select example">
                <option selected>تعداد مسافران</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div>-->
              <div class="col-md-2">
                <button
                  type="button"
                  @click="sendHotel"
                  class="btn yellow-btn w-100 mt-md-0 mt-2"
                >
                  جستجو
                </button>
              </div>
            </form>
          </div>
          <!--<div
            class="tab-pane fade"
            id="keridor"
            role="tabpanel"
            aria-labelledby="keridor-tab"
          >
            ...
          </div>-->
          <div
            class="tab-pane fade"
            id="restaurants"
            role="tabpanel"
            aria-labelledby="restaurants-tab"
          >
            <form class="row g-3 input-frm mt-0 top-search">
              <div class="col-md-2 col-6 mb-md-0 mb-2">
                <select
                  class="form-select border-blue text-muted f-12 p-2"
                  aria-label="Default select example"
                  v-model="restCity_id"
                >
                  <option selected value="">انتخاب شهر</option>
                  <option
                    v-for="city in cities"
                    :key="city.id"
                    :value="city.id"
                  >
                    {{ city.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-2 col-6">
                <input
                  type="text"
                  class="form-control"
                  id="transDate"
                  placeholder="نام محله"
                />
              </div>
              <div class="col-md-6">
                <input
                  type="text"
                  class="form-control"
                  id="transDate"
                  placeholder="جستجوی رستوران"
                  v-model="restSearch"
                />
              </div>
              <div class="col-md-2">
                <button
                  @click="sendRestaurant"
                  type="button"
                  class="btn yellow-btn w-100 mt-md-0 mt-2"
                >
                  جستجو
                </button>
              </div>
            </form>
          </div>
          <div
            class="tab-pane fade"
            id="tour"
            role="tabpanel"
            aria-labelledby="tour-tab"
          >
            <form class="row g-3 input-frm mt-0 top-search">
              <div class="col-md-2 mb-md-0 mb-2">
                <!-- <input
                type="text"
                class="form-control"
                id="typeHotel"
                placeholder="نوع حمل و نقل"
              /> -->
                <!-- multiple -->
                <multiselect
                  v-model="tourGo_vehicle_id"
                  :options="tourVehicleItems"
                  :multiple="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="نوع حمل و نقل"
                  selectLabel=""
                  selectedLabel="انتخاب شده"
                  deselectLabel=""
                  label="title"
                  track-by="id"
                  :preselect-first="false"
                >
                </multiselect>
              </div>
              <div class="col-md-4 mb-2 mb-md-0">
                <div
                  class="input-group bg-white rounded border align-items-center gap-1"
                >
                  <!-- <input
                  type="text"
                  class="form-control border-0 f-12 text-center"
                  placeholder="انتخاب مبدا "
                  aria-describedby="basic-addon1"
                /> -->
                  <select
                    v-model="tourOrigin"
                    class="form-select border-blue text-muted f-12 p-2"
                    aria-label="Default select example"
                    style="border: 0 !important"
                  >
                    <option selected value="">انتخاب مبدا</option>
                    <option
                      v-for="city in cities"
                      :key="city.id"
                      :value="city.id"
                    >
                      {{ city.name }}
                    </option>
                  </select>
                  <ExchangeIcon class="d-block" />
                  <select
                    v-model="tourDestination"
                    class="form-select border-blue text-muted f-12 p-2"
                    aria-label="Default select example"
                    style="border: 0 !important"
                  >
                    <option selected value="">انتخاب مقصد</option>
                    <option
                      v-for="city in cities"
                      :key="city.id"
                      :value="city.id"
                    >
                      {{ city.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2 col-6">
                <!-- <input
                type="text"
                class="form-control"
                id="transDate"
                placeholder="تعیین تاریخ رفت و برگشت"
              /> -->
                <date-picker
                  v-model="tourDate_range"
                  range
                  placeholder=" تاریخ رفت و برگشت"
                  clearable
                  format="YYYY-MM-DD"
                  display-format="jMMMM jD"
                />
              </div>
              <div class="col-md-2 col-6">
                <select
                  v-model="passengers_count"
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option selected value="">تعداد مسافران</option>
                  <option value="1">1 نفر</option>
                  <option value="2">2 نفر</option>
                  <option value="3">3 نفر</option>
                  <option value="4">4 نفر</option>
                  <option value="5">5 نفر</option>
                  <option value="6">6 نفر</option>
                  <option value="7">7 نفر</option>
                  <option value="8">8 نفر</option>
                  <option value="9">9 نفر</option>
                  <option value="10">10 نفر</option>
                </select>
              </div>
              <div class="col-md-2">
                <button
                  @click="sendTours"
                  type="button"
                  class="btn yellow-btn w-100 mt-md-0 mt-2"
                >
                  جستجو
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-1-container">
      <div class="coridor-banner col-10 m-auto position-relative">
        <div>
          <div class="f-24 fw-bold text-yellow d-inline-block">
            دیگه نگران وضعیت جاده ها نباش...
          </div>
        </div>
        <div>
          <div class="f-18 mt-2 d-inline-block">
            با ورود به این بخش بهترین مسیر از لحاظ کیفیت و هزینه تجربه کن!
          </div>
        </div>
        <div class="mt-5 pe-5 text-end banner-btn-container">
          <router-link
            to="/corridor"
            :class="{
              'link-active': this.$route.name == 'corridor',
            }"
            class="btn rounded-btn text-white f-12 px-5"
            >مشاهده</router-link
          >
        </div>
      </div>
    </div>
    <!-- <section class="starOfHotels-container col-10 m-auto">
      <div class="header-section mt-4">
        <div class="f-18 fw-bold">
          دنبال هتل <span class="text-darkgreen">چند ستاره ای ؟</span>
        </div>
      </div>
      <div class="content-section mt-5">
        <div class="row hotelStars">
          <div class="col-md-3 col-6">
            <div class="hotelStar apHotel">
              <img src="/assets/img/ap-img.png" alt="apartment" />
              <div class="bottomStar">هتل آپارتمان</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="hotelStar three-stars">
              <img src="/assets/img/3star-img.png" alt="apartment" />
              <div class="bottomStar">هتل سه ستاره</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="hotelStar four-stars">
              <img src="/assets/img/4star-img.png" alt="apartment" />
              <div class="bottomStar">هتل چهار ستاره</div>
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="hotelStar five-stars">
              <img src="/assets/img/5star-img.png" alt="apartment" />
              <div class="bottomStar">هتل پنج ستاره</div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <section class="map-container1 col-10 m-auto pt-2">
      <div class="header-section mt-md-5 mt-2">
        <div class="f-18 fw-bold">
          به کدوم استان میخوای <span class="text-primary"> سفر کنی ؟ </span>
        </div>
        <div class="text-gray2 mt-1">
          مقصدتو انتخاب کن تا راهنمای کامل گردشگری تو استان برات بالا بیاریم!
        </div>
      </div>
      <div class="content-section mt-5">
        <div class="row">
          <div><Map /></div>
        </div>
      </div>
    </section>
    <section class="discount-container col-10 m-auto mt-5">
      <div v-if="!resHomeLoading">
        <div v-if="resHomeShow == 2 && restaurant.length > 0">
          <div class="header-section d-flex justify-content-between">
            <!--<div>رزرو هتل های <span class="text-white">تخفیف دار</span></div>-->
            <div>رزرو رستوران</div>
            <router-link
              to="/restaurant"
              class="btn green-outline f-12 d-none d-md-block"
            >
              مشاهده همه رستوران ها
            </router-link>
          </div>
          <div class="section-content h-100">
            <div class="discount-slider">
              <swiper
                :slides-per-view="3"
                :space-between="10"
                :navigation="true"
                class="discount-slider-container has-green-outline-arrow h-100"
                :loop="false"
                :key="swiperSliderKey"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                :breakpoints="{
                  '0': {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                  '768': {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  '1024': {
                    slidesPerView: 3,
                  },
                }"
              >
                <swiper-slide
                  class="position-relative"
                  v-for="(restItem, index) in restaurant"
                  :key="index"
                >
                  <div class="discount-item">
                    <div class="img-container">
                      <img
                        :src="restItem.image_url"
                        alt=""
                        onerror="this.src='../assets/img/no-img.jpg'"
                      />
                    </div>
                    <div class="item-content p-2">
                      <div class="d-flex justify-content-between">
                        <div class="f-13">رستوران {{ restItem.name }}</div>
                        <!--<div class="discount-percent">25%</div>-->
                      </div>
                      <div>
                        <img src="/assets/img/stars.png" alt="" />
                      </div>
                      <div
                        class="rest-description"
                        v-html="strLimit(restItem.description, 150, true)"
                      ></div>
                      <!--<ul
                        class="m-0 f-10 mt-2 d-inline-flex prop-container col-auto"
                      >
                        <li>یک خواب</li>
                        <li>گیلان</li>
                        <li>فومن</li>
                      </ul>-->
                      <!--<div class="mt-2">
                        <div class="text-gray text-trough-line">93.000</div>
                      </div>-->
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <!--<div>
                          63,500 تومان
                          <span class="text-gray2 f-12">/ هرشب</span>
                        </div>-->
                        <router-link
                          :to="`/restaurant/${restItem.id}`"
                          class="btn green-outline rounded-50 px-4 shadow-none"
                        >
                          رزرو
                        </router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div v-if="resHomeShow == 0 && homeHotels.length > 0">
          <div class="header-section d-flex justify-content-between">
            <!--<div>رزرو هتل های <span class="text-white">تخفیف دار</span></div>-->
            <div>رزرو هتل</div>
            <router-link
              to="/residence"
              class="btn green-outline f-12 d-none d-md-block"
            >
              مشاهده همه هتل ها
            </router-link>
          </div>
          <div class="section-content h-100">
            <div class="discount-slider">
              <swiper
                :slides-per-view="3"
                :space-between="10"
                :navigation="true"
                class="discount-slider-container has-green-outline-arrow h-100"
                :loop="false"
                :key="swiperSliderKey"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                :breakpoints="{
                  '0': {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                  '768': {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  '1024': {
                    slidesPerView: 3,
                  },
                }"
              >
                <swiper-slide
                  class="position-relative"
                  v-for="(hotelItem, index) in homeHotels"
                  :key="index"
                >
                  <div class="discount-item">
                    <div class="img-container">
                      <img
                        v-if="hotelItem.images.length > 0"
                        :src="hotelItem.images[0].url"
                        alt=""
                        onerror="this.src='../assets/img/no-img.jpg'"
                      />
                      <img v-else src="/assets/img/no-img.jpg" alt="" />
                    </div>
                    <div class="item-content p-2">
                      <div class="d-flex justify-content-between">
                        <div class="f-13">{{ hotelItem.name }}</div>
                        <!--<div class="discount-percent">25%</div>-->
                      </div>
                      <div>
                        <star-rating
                          v-bind:increment="0.05"
                          inactive-color="#a6a6a6"
                          active-color="#fdc703"
                          v-bind:star-size="15"
                          class="slider-rating"
                          :read-only="true"
                          v-model="hotelItem.star"
                        >
                        </star-rating>
                        <!-- <img src="/assets/img/stars.png" alt="" />-->
                      </div>
                      <div
                        class="rest-description"
                        v-html="strLimit(hotelItem.description, 150, true)"
                      ></div>
                      <!--<ul
                        class="m-0 f-10 mt-2 d-inline-flex prop-container col-auto"
                      >
                        <li>یک خواب</li>
                        <li>گیلان</li>
                        <li>فومن</li>
                      </ul>-->
                      <!--<div class="mt-2">
                        <div class="text-gray text-trough-line">93.000</div>
                      </div>-->
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          {{ hotelItem.price_start }} تومان
                          <!--<span class="text-gray2 f-12">/ هرشب</span>-->
                        </div>
                        <router-link
                          :to="`/residence/${hotelItem.id}`"
                          class="btn green-outline rounded-50 px-4 shadow-none"
                        >
                          رزرو
                        </router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div v-if="resHomeShow == 1 && homeHotels.length > 0">
          <div class="header-section d-flex justify-content-between">
            <!--<div>رزرو هتل های <span class="text-white">تخفیف دار</span></div>-->
            <div>رزرو اقامتگاه</div>
            <router-link
              to="/residence"
              class="btn green-outline f-12 d-none d-md-block"
            >
              مشاهده همه اقامتگاه ها
            </router-link>
          </div>
          <div class="section-content h-100">
            <div class="discount-slider">
              <swiper
                :slides-per-view="3"
                :space-between="10"
                :navigation="true"
                class="discount-slider-container has-green-outline-arrow h-100"
                :loop="false"
                :key="swiperSliderKey"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                :breakpoints="{
                  '0': {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                  '768': {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  '1024': {
                    slidesPerView: 3,
                  },
                }"
              >
                <swiper-slide
                  class="position-relative"
                  v-for="(hotelItem, index) in homeHotels"
                  :key="index"
                >
                  <div class="discount-item">
                    <div class="img-container">
                      <img
                        v-if="hotelItem.images.length > 0"
                        :src="hotelItem.images[0].url"
                        alt=""
                        onerror="this.src='../assets/img/no-img.jpg'"
                      />
                      <img v-else src="/assets/img/no-img.jpg" alt="" />
                    </div>
                    <div class="item-content p-2">
                      <div class="d-flex justify-content-between">
                        <div class="f-13">{{ hotelItem.name }}</div>
                        <!--<div class="discount-percent">25%</div>-->
                      </div>
                      <div>
                        <star-rating
                          v-bind:increment="0.05"
                          inactive-color="#a6a6a6"
                          active-color="#fdc703"
                          v-bind:star-size="15"
                          class="slider-rating"
                          :read-only="true"
                          v-model="hotelItem.star"
                        >
                        </star-rating>
                        <!-- <img src="/assets/img/stars.png" alt="" />-->
                      </div>
                      <div
                        class="rest-description"
                        v-html="strLimit(hotelItem.description, 150, true)"
                      ></div>
                      <!--<ul
                        class="m-0 f-10 mt-2 d-inline-flex prop-container col-auto"
                      >
                        <li>یک خواب</li>
                        <li>گیلان</li>
                        <li>فومن</li>
                      </ul>-->
                      <!--<div class="mt-2">
                        <div class="text-gray text-trough-line">93.000</div>
                      </div>-->
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          {{ hotelItem.price_start }} تومان
                          <!--<span class="text-gray2 f-12">/ هرشب</span>-->
                        </div>
                        <router-link
                          :to="`/residence/${hotelItem.id}`"
                          class="btn green-outline rounded-50 px-4 shadow-none"
                        >
                          رزرو
                        </router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div v-if="resHomeShow == 3 && tour.length > 0">
          <div class="header-section d-flex justify-content-between">
            <!--<div>رزرو هتل های <span class="text-white">تخفیف دار</span></div>-->
            <div>رزرو تور</div>
            <router-link
              to="/tour"
              class="btn green-outline f-12 d-none d-md-block"
            >
              مشاهده همه تور ها
            </router-link>
          </div>
          <div class="section-content h-100">
            <div class="discount-slider">
              <swiper
                :slides-per-view="3"
                :space-between="10"
                :navigation="true"
                class="discount-slider-container has-green-outline-arrow h-100"
                :loop="false"
                :key="swiperSliderKey"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                :breakpoints="{
                  '0': {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                  },
                  '768': {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  '1024': {
                    slidesPerView: 3,
                  },
                }"
              >
                <swiper-slide
                  class="position-relative"
                  v-for="(tourItem, index) in tour"
                  :key="index"
                >
                  <div class="discount-item">
                    <div class="img-container">
                      <img
                        :src="tourItem.image_url"
                        alt=""
                        onerror="this.src='../assets/img/no-img.jpg'"
                      />
                    </div>
                    <div class="item-content p-2">
                      <div class="d-flex justify-content-between">
                        <div class="f-13">
                          {{ tourItem.name }} ({{
                            tourItem.vehicletypego.title
                          }})
                        </div>
                        <div class="discount-percent">
                          {{ tourItem.discount }}%
                        </div>
                      </div>
                      <div class="text-red my-1 f-11">
                        گنجایش : {{ tourItem.capacity }}
                      </div>
                      <div
                        class="rest-description"
                        v-html="strLimit(tourItem.comment, 150, true)"
                      ></div>
                      <!--<ul
                        class="m-0 f-10 mt-2 d-inline-flex prop-container col-auto"
                      >
                        <li>یک خواب</li>
                        <li>گیلان</li>
                        <li>فومن</li>
                      </ul>-->
                      <!--<div class="mt-2">
                        <div class="text-gray text-trough-line">93.000</div>
                      </div>-->
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          {{ tourItem.price }} تومان
                          <!--<span class="text-gray2 f-12">/ هرشب</span>-->
                        </div>
                        <router-link
                          :to="`/tour/${tourItem.id}`"
                          class="btn green-outline rounded-50 px-4 shadow-none"
                        >
                          رزرو
                        </router-link>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center p-3">
        <img src="/assets/img/ladng-circle.gif" alt="" width="50" />
      </div>
    </section>
    <section class="faq-container col-10 m-auto mt-5">
      <div class="row">
        <div class="col-md-6">
          <div class="header-section">
            سوالات
            <span class="text-darkgreen">متداول</span>
          </div>
          <div
            class="accordion mt-4"
            id="accordionExample"
            v-if="faq.length > 0"
          >
            <div
              class="accordion-item"
              v-for="(item, index) in faq"
              :key="index"
            >
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse${index}`"
                  aria-expanded="true"
                  :aria-controls="`#collapse${index}`"
                >
                  {{ item.title }}
                </button>
              </h2>
              <div
                :id="`collapse${index}`"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  {{ item.reply }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <img src="/assets/img/faq-img.png" class="w-100" alt="" />
        </div>
      </div>
    </section>
    <section class="article-container col-10 m-auto mt-5">
      <div class="row h-100">
        <div
          class="col-md-6 cursor-pointer h-100 mb-md-0 mb-2"
          @click="openBlog(1)"
        >
          <div class="h-100 has-blue-title">
            <img src="/assets/img/article1.png" class="h-100 w-100" alt="" />
            <div class="blue-title fw-bold f-13">نقاط گردشگری ثبت یونسکو</div>
          </div>
        </div>
        <div class="col-md-6 ps-md-0 h-100">
          <div class="row h-50">
            <div class="col-6 h-100 pb-1 cursor-pointer" @click="openBlog(6)">
              <div class="h-100 has-blue-title">
                <img
                  src="/assets/img/blog4.png"
                  class="h-100 w-100 small-img"
                  alt=""
                />
                <div class="blue-title fw-bold f-13">میراث ناملموس</div>
              </div>
            </div>
            <div
              class="col-6 h-100 pb-1 ps-0 cursor-pointer"
              @click="openBlog(5)"
            >
              <div class="h-100 has-blue-title">
                <img
                  src="/assets/img/blog1.png"
                  class="h-100 w-100 small-img"
                  alt=""
                />
                <div class="blue-title fw-bold f-13">جاذبه های تاریخی</div>
              </div>
            </div>
          </div>
          <div class="row h-50">
            <div class="col-6 h-100 pt-1 cursor-pointer" @click="openBlog(3)">
              <div class="h-100 has-blue-title">
                <img
                  src="/assets/img/blog3.png"
                  class="h-100 w-100 small-img"
                  alt=""
                />
                <div class="blue-title fw-bold f-13">نقاط صنایع دستی</div>
              </div>
            </div>
            <div
              class="col-6 h-100 pt-1 ps-0 cursor-pointer"
              @click="openBlog(2)"
            >
              <div class="h-100 has-blue-title">
                <img
                  src="/assets/img/exersice.jpg"
                  class="h-100 w-100 small-img"
                  alt=""
                />
                <div class="blue-title fw-bold f-13">نقاط ورزشی</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Navigation, Pagination } from "swiper";

import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import HotelIcon from "../assets/svg/HoteIcon.svg";
import Eghamatgah from "../assets/svg/Eghamatgah.svg";
import CoridorIcon from "../assets/svg/CoridorIcon.svg";
import RsturanIcon from "../assets/svg/RsturanIcon.svg";
import TurIcon from "../assets/svg/TurIcon.svg";
import esfeahn from "../assets/svg/stat-icons/esfeahn.svg";
import Alborz from "../assets/svg/stat-icons/Alborz.svg";
import Ardebil from "../assets/svg/stat-icons/Ardebil.svg";
import azarbayjanegharbi from "../assets/svg/stat-icons/azarbayjanegharbi.svg";
import azarbayjanesharghi from "../assets/svg/stat-icons/azarbayjanesharghi.svg";
import booshehr from "../assets/svg/stat-icons/booshehr.svg";
import charmahalbakhtiari from "../assets/svg/stat-icons/charmahalbakhtiari.svg";
import Ghom from "../assets/svg/stat-icons/Ghom.svg";
import gilan from "../assets/svg/stat-icons/gilan.svg";
import hamedan from "../assets/svg/stat-icons/hamedan.svg";
import Hormozgan from "../assets/svg/stat-icons/Hormozgan.svg";
import karaj from "../assets/svg/stat-icons/karaj.svg";
import Kerman from "../assets/svg/stat-icons/Kerman.svg";
import kermansha from "../assets/svg/stat-icons/hamedan.svg";
import khorasanjonobi from "../assets/svg/stat-icons/khorasanjonobi.svg";
import khorasanshomali from "../assets/svg/stat-icons/khorasanshomali.svg";
import khozestan from "../assets/svg/stat-icons/khozestan.svg";
import eilam from "../assets/svg/stat-icons/eilam.svg";
import Kordestan from "../assets/svg/stat-icons/Kordestan.svg";
import Lorestan from "../assets/svg/stat-icons/Lorestan.svg";
import markazi from "../assets/svg/stat-icons/markazi.svg";
import Mashhad from "../assets/svg/stat-icons/Mashhad.svg";
import mazandaran from "../assets/svg/stat-icons/mazandaran.svg";
import ghazvin from "../assets/svg/stat-icons/ghazvin.svg";
import semnan from "../assets/svg/stat-icons/semnan.svg";
import shiraz from "../assets/svg/stat-icons/shiraz.svg";
import sistanobalochestan from "../assets/svg/stat-icons/sistanobalochestan.svg";
import tabriz from "../assets/svg/stat-icons/tabriz.svg";
import Tehran from "../assets/svg/stat-icons/Tehran.svg";
import yazd from "../assets/svg/stat-icons/yazd.svg";
import zanjan from "../assets/svg/stat-icons/zanjan.svg";
import fars from "../assets/svg/stat-icons/fars.svg";
import golestan from "../assets/svg/stat-icons/golestan.svg";
import Map from "./Map.vue";
import StarRating from "vue-star-rating";
import axios from "axios";
import Multiselect from "vue-multiselect";
// Import Swiper styles
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination]);
// import IranMapVue from "iran-map-vue";
export default {
  name: "HomeView",
  data() {
    return {
      swiper: null,
      swiperSliderKey: 0,
      provinces: { Isfahan: { color: "#3e3ec9" } },
      faq: [],
      homeHotels: [],
      restaurant: [],
      resHomeShow: 0,
      resHomeLoading: false,
      residence: [],
      tour: [],
      cities: [],
      restSearch: "",
      restCity_id: "",
      tourGo_vehicle_id: [],
      tourVehicleItems: [
        {
          title: "خودرو شخصی",
          id: 1,
        },
        {
          title: "قطار",
          id: 2,
        },
        {
          title: "اتوبوس",
          id: 3,
        },
        {
          title: "هواپیما",
          id: 4,
        },
      ],
      tourOrigin: "",
      tourDestination: "",
      tourDate_range: [],
      passengers_count: "",
      residenceName: "",
      hotelCities: [],
      hotelName: "",
      hotelCitySelected: "0",
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    StarRating,
    //IranMapVue,
    HotelIcon,
    Eghamatgah,
    CoridorIcon,
    RsturanIcon,
    esfeahn,
    TurIcon,
    Ardebil,
    Alborz,
    hamedan,
    gilan,
    Ghom,
    charmahalbakhtiari,
    booshehr,
    azarbayjanegharbi,
    markazi,
    Lorestan,
    Kordestan,
    eilam,
    khozestan,
    khorasanjonobi,
    kermansha,
    Kerman,
    karaj,
    Hormozgan,
    zanjan,
    yazd,
    Tehran,
    tabriz,
    sistanobalochestan,
    shiraz,
    semnan,
    ghazvin,
    mazandaran,
    Mashhad,
    azarbayjanesharghi,
    khorasanshomali,
    fars,
    golestan,
    Map,
    Multiselect,
  },
  methods: {
    getImageUrl(imageId) {
      return `https://picsum.photos/600/400/?image=${imageId}`;
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    onSlideChange() {
      console.log("slide change");
    },
    _hoverMap(item) {
      console.log(item);
    },
    _clickMap(item) {
      console.log(item);
    },
    openBlog(id) {
      this.$router.push({ name: "blog", query: { category_id: id } });
    },
    async getFaq() {
      this.$store.state.loading = true;

      try {
        const response = await this.$https.get(`/question/api/home`);
        response.data.data.map((item) => {
          this.faq.push(item);
        });
        this.$store.state.loading = false;
        console.log(this.faq);
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    },
    async getRestaurant() {
      this.$store.state.loading = true;
      this.resHomeLoading = true;
      this.resHomeShow = 2;
      try {
        const response = await this.$https.get(
          `/restaurant/api/restaurants?per_page=6`
        );
        this.restaurant = response.data.data.data;
        this.$store.state.loading = false;
        this.resHomeLoading = false;
        this.swiperSliderKey++;
        console.log("this.restaurant", this.restaurant);
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    },
    async loadHotels() {
      this.$store.state.loading = true;
      this.resHomeLoading = true;
      this.resHomeShow = 0;

      try {
        const response = await this.$https.get(
          `/residence/api/residences?per_page=6&filter[type]=hotel`
        );
        this.homeHotels = response.data.data.data;
        console.log("homeHotels", this.homeHotels);
        this.$store.state.loading = false;
        this.resHomeLoading = false;
      } catch (errors) {
        console.log(error);
        this.$store.state.loading = false;
        this.resHomeLoading = false;
      }

      // this.$https
      //   .get(
      //     `https://api.grschannel.com/v1/properties?filters[0][operand]=Contains&filters[0][name]=city_id&filters[0][value]=37&filters[1][operand]=Contains&filters[1][name]=type&filters[1][value]=hotel`,
      //     {
      //       headers: {
      //         "Client-Token":
      //           "https://api.grschannel.com-$2y$10$966oXl96/O0ZySl3YE6bBuS",
      //         "Content-Type": "application/json",
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     // handle success
      //     console.log(response.data);
      //     this.homeHotels = response.data.value.properties.slice(0, 7);
      //     console.log("homeHotels", this.homeHotels);
      //     this.$store.state.loading = false;
      //     this.resHomeLoading = false;
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //     this.$store.state.loading = false;
      //     this.resHomeLoading = false;
      //   });
    },
    async getResidence() {
      this.resHomeLoading = true;
      this.resHomeShow = 1;

      try {
        const response = await this.$https.get(
          `//iran-safar.com/residence/api/residences?per_page=6&filter[type]=traditional_residence,inn,residential_unit`
        );
        this.homeHotels = response.data.data.data;
        console.log("homeHotels", this.homeHotels);
        this.$store.state.loading = false;
        this.resHomeLoading = false;
      } catch (errors) {
        console.log(error);
        this.$store.state.loading = false;
        this.resHomeLoading = false;
      }
    },
    async getTour() {
      this.$store.state.loading = true;
      this.resHomeLoading = true;
      this.resHomeShow = 3;
      try {
        const response = await this.$https.get(
          `tour/api/tours?per_page=6&include=vehicletypego`
        );
        this.tour = response.data.data.data;
        this.$store.state.loading = false;
        this.resHomeLoading = false;
        this.swiperSliderKey++;
        console.log("this.tour", this.tour);
      } catch (errors) {
        console.error(errors);
        this.$store.state.loading = false;
      }
    },
    strLimit(text, count, insertDots) {
      return (
        text.slice(0, count) + (text.length > count && insertDots ? "..." : "")
      );
    },
    sendRestaurant() {
      let restFilters = {};
      if (this.restSearch != "") restFilters.search = this.restSearch;
      if (this.restCity_id != "") restFilters.city_id = this.restCity_id;

      this.$router.push({
        path: "/restaurant",
        query: restFilters,
      });
    },
    sendTours() {
      console.log(this.tourGo_vehicle_id);
      var tourGo_vehicle_idIds = [];
      this.tourGo_vehicle_id.map((item) => {
        tourGo_vehicle_idIds.push(item.id);
      });
      var tourFilters = {};
      if (tourGo_vehicle_idIds.length > 0)
        tourFilters.vehicle_type = tourGo_vehicle_idIds;
      if (this.tourOrigin != "") tourFilters.origin = this.tourOrigin;
      if (this.tourDestination != "")
        tourFilters.destination = this.tourDestination;
      if (this.tourDate_range.length > 0)
        tourFilters.date = this.tourDate_range;
      if (this.passengers_count != "")
        tourFilters.passengers_count = this.passengers_count;

      console.log(tourGo_vehicle_idIds);
      this.$router.push({
        path: "/tour",
        query: tourFilters,
      });

      // this.$router.push(
      //   `/tour?vehicle_type=${tourGo_vehicle_idIds}&origin=${this.tourOrigin}&destination=${this.tourDestination}&date=${this.tourDate_range}&passengers_count=${this.passengers_count}`
      // );
    },
    sendResidence() {
      let residenceFilter = {};
      if (this.residenceName != "")
        residenceFilter.residence_name = this.residenceName;
      this.$router.push({
        path: "/residence",
        query: residenceFilter,
      });
    },
    sendHotel() {
      let hotelFilter = {};
      if (this.hotelName != "") hotelFilter.name = this.hotelName;
      if (this.hotelCitySelected != "0")
        hotelFilter.city_id = this.hotelCitySelected;

      this.$router.push({
        path: "/residence",
        query: hotelFilter,
      });
    },
  },
  mounted() {},
  async created() {
    this.loadHotels();
    // try {
    //   const response = await this.$https.get(
    //     `/corridor/api/residences?filter[category_id]=1`
    //   );
    //   this.homeHotels = response.data.data.data;
    //   this.$store.state.loading = false;
    //   this.resHomeLoading = false;

    //   console.log("homeHotels", this.homeHotels);
    // } catch (errors) {
    //   console.error(errors);
    //   this.$store.state.loading = false;
    // }

    this.$store.state.loading = true;

    try {
      const response = await this.$https.get(`/question/api/home`);
      response.data.data.map((item) => {
        this.faq.push(item);
      });
      this.$store.state.loading = false;
      console.log(this.faq);
    } catch (errors) {
      console.error(errors);
      this.$store.state.loading = false;
    }

    const { data } = await axios.get("//iran-safar.com/corridor/api/cities");
    this.cities = data.data;

    this.$store.state.loading = true;
    const hotelCitiesResponse = await axios.get(
      `https://api.grschannel.com/v1/cities`,
      {
        headers: {
          "Client-Token":
            "https://api.grschannel.com-$2y$10$966oXl96/O0ZySl3YE6bBuS",
          "Content-Type": "application/json",
        },
      }
    );
    console.log("hotelCitiesResponse", hotelCitiesResponse);
    this.hotelCities = hotelCitiesResponse.data.value.cities;
    this.$store.state.loading = false;
  },
};
</script>
